export const QueryKeys = {
    Reviews: "reviews",
} as const;
